module.exports = __webpack_public_path__ + "img/vital.d2853324.svg";